module.exports = __webpack_public_path__ + "static/media/feature-recommedation-setting@3x.9b89f73a.png";